// src/sections/CompaniesSection.jsx
import React from "react";
import CardCompany from "../components/Cards/CardCompany/CardCompany.jsx";

const SkeletonCard = () => (
    <div className="min-h-[280px] animate-pulse rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
        <div className="min-h-[132px] rounded-2xl bg-slate-100" />
        <div className="mt-5 h-6 w-24 rounded-full bg-slate-100" />
        <div className="mt-4 h-5 w-11/12 rounded bg-slate-100" />
        <div className="mt-2 h-5 w-8/12 rounded bg-slate-100" />
        <div className="mt-8 h-12 rounded-xl bg-slate-100" />
    </div>
);

const CompaniesSection = ({ companies = [], loading = false, error = null }) => {
    const safeCompanies = Array.isArray(companies) ? companies : [];

    return (
        <section className="w-full px-2 py-4 md:px-4 lg:px-6">
            <div className="mx-auto w-full max-w-7xl">
                <div className="mb-8 rounded-3xl border border-slate-200 bg-gradient-to-br from-white via-slate-50 to-blue-50 px-6 py-7 shadow-sm md:px-8">
                    <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
                        <div>
                            <p className="text-sm font-semibold uppercase tracking-[0.22em] text-blue-700">
                                Winscore
                            </p>
                            <h1 className="mt-2 text-3xl font-extrabold tracking-tight text-slate-800 md:text-4xl">
                                Organizaciones
                            </h1>
                            <p className="mt-2 max-w-2xl text-sm text-slate-600 md:text-base">
                                Selecciona una organización para ingresar a sus
                                eventos disponibles.
                            </p>
                        </div>

                        {!loading && !error ? (
                            <div className="inline-flex w-fit items-center rounded-2xl border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-slate-600 shadow-sm">
                                {safeCompanies.length} organización{safeCompanies.length === 1 ? "" : "es"}
                            </div>
                        ) : null}
                    </div>
                </div>

                {error ? (
                    <div className="mb-6 rounded-2xl border border-red-200 bg-red-50 px-4 py-4 text-sm font-medium text-red-700 shadow-sm">
                        {error}
                    </div>
                ) : null}

                {loading ? (
                    <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 xl:grid-cols-4">
                        {Array.from({ length: 8 }).map((_, index) => (
                            <SkeletonCard key={index} />
                        ))}
                    </div>
                ) : null}

                {!loading && !error && safeCompanies.length === 0 ? (
                    <div className="rounded-3xl border border-dashed border-slate-300 bg-white px-6 py-16 text-center shadow-sm">
                        <p className="text-lg font-semibold text-slate-700">
                            No hay organizaciones registradas por ahora.
                        </p>
                        <p className="mt-2 text-sm text-slate-500">
                            Cuando existan compañías disponibles, aparecerán aquí.
                        </p>
                    </div>
                ) : null}

                {!loading && !error && safeCompanies.length > 0 ? (
                    <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 xl:grid-cols-4">
                        {safeCompanies.map((company) => (
                            <CardCompany
                                key={company?.idcompany ?? `${company?.name || "company"}-${company?.abrev || ""}`}
                                company={company}
                            />
                        ))}
                    </div>
                ) : null}
            </div>
        </section>
    );
};

export default CompaniesSection;
